import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material';
import { MatTableDataSource } from '@angular/material/table';
import { AddFromListDialogData } from './affected-tag-dialog.data';

export interface IDeployedPackagesTable {
    id: string;
    name: string;
    schema: string;
    type: number;
}

@Component({
    selector : 'affected-tag-dialog',
    template: require('./affected-tag-dialog.component.html'),
    styles: [require('./affected-tag-dialog.component.scss')]
})


export class AffectedDialogComponent {
    public dataSource = new MatTableDataSource<IDeployedPackagesTable>([]);
    public displayedColumns = ['Id', 'Name', 'Schema', 'Type'];

    constructor(@Inject(MAT_DIALOG_DATA) public data: AddFromListDialogData) {
        const table = [];
        data.elements.forEach((item) => {
            table.push({
                id: item.id,
                name: item.name,
                schema: item.schema,
                type: item.type,
            });
        });
        this.dataSource.data = table;
    }


}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/shared/components/dialogs/affected-tag-dialog/affected-tag-dialog.component.ts